// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-key-value {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  width: 100%;
}
.conn-form-key-value__add-button-wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 2px;
}
.conn-form-key-value__add-button {
  width: -moz-fit-content;
  width: fit-content;
}
.conn-form-key-value__add-button-error-message {
  color: var(--g-color-text-danger);
}
.conn-form-key-value__entry {
  display: flex;
  column-gap: 10px;
}
.conn-form-key-value__key-select {
  flex-shrink: 0;
  max-width: 40%;
}
.conn-form-key-value__value-input {
  flex-shrink: 1;
  flex-basis: auto;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/components/KeyValue/KeyValue.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACR;AAEI;EACI,uBAAA;EAAA,kBAAA;AAAR;AAGI;EACI,iCAAA;AADR;AAII;EACI,aAAA;EACA,gBAAA;AAFR;AAKI;EACI,cAAA;EACA,cAAA;AAHR;AAMI;EACI,cAAA;EACA,gBAAA;AAJR","sourcesContent":[".conn-form-key-value {\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n  width: 100%;\n}\n.conn-form-key-value__add-button-wrapper {\n  display: flex;\n  flex-direction: column;\n  row-gap: 2px;\n}\n.conn-form-key-value__add-button {\n  width: fit-content;\n}\n.conn-form-key-value__add-button-error-message {\n  color: var(--g-color-text-danger);\n}\n.conn-form-key-value__entry {\n  display: flex;\n  column-gap: 10px;\n}\n.conn-form-key-value__key-select {\n  flex-shrink: 0;\n  max-width: 40%;\n}\n.conn-form-key-value__value-input {\n  flex-shrink: 1;\n  flex-basis: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
